export default "c6ac5a2389f29fa6.png"